import React from 'react';
import PropTypes from 'prop-types';

const RfiLinkedEntitiesCellItem = ({ entity }) => {
  const cellValue = entity.identifier ? `#${entity.identifier}` : entity.title;
  return <span>{cellValue}</span>;
};

RfiLinkedEntitiesCellItem.propTypes = {
  /**
   * The RFI entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    identifier: PropTypes.string
  }).isRequired
};

export default RfiLinkedEntitiesCellItem;
